import request from "superagent";
import SearchApi from "../api/search.api";
import * as actionTypes from "Consts/index";
import {useSelector} from "react-redux";

export const get = (
    searchHits,
    query,
    take,
    skip,
    searchHitsText,
    culture,
    types,
    startPageId,
    currentPageId,
    takeNrFromPage,
    initial,
    totalHits,
    orderResultsBy,
    categories,
    notInId,
    priorityId
) => {
    return (dispatch) => {
        dispatch({
            type: actionTypes.SEARCH__LOADING,
            payload: true,
        });
        if (initial) {
            dispatch({
                type: actionTypes.SEARCH__GET,
                payload: {
                    items: searchHits,
                    TotalCount: totalHits,
                    query: query,
                    culture: culture,
                    types: types,
                    startPageId: startPageId,
                    currentPageId: currentPageId,
                    searchHitsText: searchHitsText,
                    takeNrFromPage: takeNrFromPage,
                    orderResultsBy: orderResultsBy,
                    categories: categories,
                    notInId: notInId,
                    priorityId: priorityId,
                },
            });
            dispatch({
                type: actionTypes.SEARCH__LOADING,
                payload: false,
            });
            return;
        }
        SearchApi.getItems(
            query,
            take,
            skip,
            culture,
            types,
            startPageId,
            currentPageId,
            takeNrFromPage,
            orderResultsBy,
            categories,
            notInId,
            priorityId
        )
            .then((res) => {
                const {
                    SearchHits,
                    TotalHits,
                    SearchQuery: {
                        Query,
                        CurrentCulture,
                        DocumentTypes,
                        CurrentPageId,
                        Skip,
                        StartPageId,
                        Take,
                        SearchHitsText,
                        TakeNrFromPage,
                        Categories,
                        NotInId,
                        PriorityId,
                        OrderResultsBy
                    },
                } = res;
                dispatch({
                    type: actionTypes.SEARCH__GET,
                    payload: {
                        items: SearchHits,
                        TotalCount: TotalHits,
                        query: Query,
                        culture: CurrentCulture,
                        types: DocumentTypes,
                        startPageId: StartPageId,
                        currentPageId: CurrentPageId,
                        searchHitsText: SearchHitsText,
                        takeNrFromPage: TakeNrFromPage,
                        categories: Categories,
                        notInId: NotInId,
                        priorityId: PriorityId,
                        orderResultsBy: OrderResultsBy
                    },
                });
                dispatch({
                    type: actionTypes.SEARCH__LOADING,
                    payload: false,
                });
            })
            .catch((e) => console.error(e));
    };
};

export const more = (
    query,
    take,
    skip,
    culture,
    types,
    startPageId,
    currentPageId,
    takeNrFromPage,
    categories,
    notInId,
    priorityId,
    orderResultsBy
) => {
    return (dispatch) => {
        dispatch({
            type: actionTypes.SEARCH__LOADING,
            payload: true,
        });
        SearchApi.getItems(
            query,
            take,
            skip,
            culture,
            types,
            startPageId,
            currentPageId,
            takeNrFromPage,
            categories,
            notInId,
            priorityId,
            orderResultsBy
        )
            .then((res) => {
                const {
                    SearchHits,
                    TotalHits,
                    SearchQuery: {
                        Query,
                        CurrentCulture,
                        DocumentTypes,
                        CurrentPageId,
                        Skip,
                        StartPageId,
                        Take,
                        SearchHitsText,
                        TakeNrFromPage,
                        Categories,
                        NotInId,
                        PriorityId,
                        OrderResultsBy
                    },
                } = res;
                dispatch({
                    type: actionTypes.SEARCH__MORE,
                    payload: {
                        items: SearchHits,
                        TotalCount: TotalHits,
                        query: Query,
                        culture: CurrentCulture,
                        types: DocumentTypes,
                        startPageId: StartPageId,
                        currentPageId: CurrentPageId,
                        searchHitsText: SearchHitsText,
                        takeNrFromPage: TakeNrFromPage,
                        categories: Categories,
                        notInId: NotInId,
                        priorityId: PriorityId,
                        orderResultsBy: OrderResultsBy
                    },
                });
                dispatch({
                    type: actionTypes.SEARCH__LOADING,
                    payload: false,
                });
            })
            .catch((e) => console.error(e));
    };
};
